<template>
    <div>
        <div class="header">
            Maak een nieuw pushbericht
        </div>
        <form v-on:submit.prevent>
            <div class="item-wrapper">
                <div class="item-image">
                    <img :src="image.thumbor_url">
                </div>
                <div class="item-details">
                    <div>
                        <input v-model="articleUrl" type="text" id="url" placeholder="Plak hier een artikel URL om een pushbericht te maken" :class="articleUrlClass">
                    </div>
                    <div>
                        <textarea v-model="title" id="title" placeholder="Bericht"></textarea>
                        <span :class="charLeftClass">Aantal karakters over: <strong>{{messageCharLeft}}</strong></span>
                    </div>
                    <div class="controls">
                        <select id="filter"
                            v-model="channel"
                            class="select"
                            :class="channelClass"
                            title="Kies een kanaal om waar u dit bericht naar toe wilt pushen"
                        >
                            <option value="all">Kies een kanaal:</option>
                            <option :value="k" v-for="(v, k) in channels" :key="k">
                                {{ v }}
                            </option>
                        </select>
                        <div class="item-data-input">
                            <label for="scheduled-time">Plan hier uw bericht in (Als u hier niks invoert wordt het bericht direct gestuurd):</label>
                            <input type="datetime-local" name="scheduled-time" v-model="scheduledTime">
                        </div>
                        <div class="send">
                            <button @click="sendNotification" :disabled="!enableSend">Verstuur bericht</button>
                        </div>
                    </div>
                    <div class="feedback">
                        <transition name="slide-fade">
                            <div class="sending" v-if="sending">

                                <div class="text">
                                    <div class="innertext">
                                        Weet u zeker dat u dit bericht wilt pushen naar alle devices in het kanaal <strong>{{ channels[channel] }}</strong>?
                                    </div>
                                </div>
                                <div>
                                    <button @click.once="sendConfirm">Zeker Weten!</button>
                                </div>
                            </div>
                        </transition>
                        <transition name="slide-fade">
                            <div class="already-sent" v-if="alreadySent">
                                <div class="sending">
                                    <div class="text">
                                        <div class="innertext">
                                            WAARSCHUWING: Dit artikel is al {{ alreadySent.length }} keer eerder als pushbericht verzonden:
                                            <ListNotifications
                                                :notifications="alreadySent"
                                                :channels="channels"
                                                header="none"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="sending">
                                    <div class="text">
                                        <div class="innertext">
                                            Weet u zeker dat u dit bericht toch wilt sturen naar alle devices in het kanaal <strong>{{ channels[channel] }}</strong>?
                                        </div>
                                    </div>
                                    <div>
                                        <button @click.once="sendConfirm">Zeker Weten!</button>
                                    </div>

                                </div>
                            </div>
                        </transition>
                        <transition name="slide-fade">
                            <div class="sent" v-if="sent">
                                Het pushbericht is verstuurd naar <strong>{{ channels[sentToChannel] }}</strong>.
                            </div>
                        </transition>
                        <transition name="slide-fade">
                            <div class="sendError" v-if="sendError">
                                {{ sendError }}
                            </div>
                        </transition>
                        <transition name="slide-fade">
                            <div class="sendError" v-if="warnNoItemFound">
                                Fout: er is geen item voor dit artikel gevonden. Controleer de URL en probeer opnieuw.
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import ListNotifications from './ListNotifications';
    import moment from 'moment';

    const CHANNEL_TITLES = {
        "breaking_news": "Nieuws",
        "highlights": "Het beste van NRC"
    }

    const defaultImage=  {
        thumbor_url: '/default-image.svg'
    }

    export default {
        props: ['channels'],
        components: {
            ListNotifications
        },
        data: () => ({
            articleUrl: '',
            image: defaultImage,
            title: '',
            channel: 'all',
            sentToChannel: '',
            previousUrl: '',
            sending: false,
            sendError: false,
            sendResult: false,
            sent: false,
            alreadySent: false,
            forceSend: false,
            warnNoItemFound: false,
            scheduledTime: null
        }),
        computed: {
            articleId () {
                const url = this.articleUrl
                const n = url.lastIndexOf("-a")
                const id = url.substring(n+2)
                if (n > -1 && !isNaN(id)) {
                    return id
                } else {
                    return 0
                }
            },
            articleUrlValid () {
                return this.articleId !== 0 && this.articleUrl.startsWith('https://')
            },
            articleUrlClass () {
                return this.articleUrl && !this.articleUrlValid ? 'highlight' : ''
            },
            channelClass() {
                return this.articleId !== 0 && this.channel === 'all' ? 'highlight': ''
            },
            enableSend() {
                return this.articleId !== 0 && this.title && this.channel !== 'all'
            },
            messageCharLeft() {
                return 144 - this.title.length
            },
            charLeftClass() {
                return (this.messageCharLeft < 0) ? "red" : "green";
            },

        },
        methods: {
            sendNotification() {
                this.sendError = false
                this.sent = false
                // check if this article has already been pushed
                this.$api.getNotification(this.articleId)
                    .then(data => {
                        if (data.length > 0) {
                            this.alreadySent = data
                            this.forceSend = true
                        } else {
                            this.sending = true
                        }
                    })
            },
            sendConfirm() {
                this.sending = false
                this.alreadySent = false
                // construct the data to be sent to the back end
                let checkurl = new URL(this.articleUrl)
                let url = this.articleUrl
                if (checkurl.search.length === 0) {
                    url = url + '?utm_source=push&utm_medium=' + this.channel + '&utm_term=' + moment(Date.now()).format('YYYYMMDD')
                }
                const data = {
                    channel: this.channel,
                    article_id: parseInt(this.articleId),
                    title: CHANNEL_TITLES[this.channel],
                    body: this.title,
                    url: url,
                    image: {
                        url: this.image.url,
                    },
                    force_send: this.forceSend,
                }

                if (this.scheduledTime) {
                    data['scheduled_time'] = moment(this.scheduledTime).toISOString()
                }
                const crop = this.image.crop
                if (crop && crop.left !== null && crop.top !== null && crop.width !== null && crop.height !== null) {
                    data.image.crop = crop
                }
                this.$api.sendNotification(data)
                    .then(response => {
                        this.sentToChannel = this.channel
                        this.sent = response
                        this.clearForm()
                        this.$emit('addnotification', data)
                    })
                    .catch(error => {
                        this.sendError = error
                        // fake a successful send
                        // console.log(error)
                        // this.sentToChannel = this.channel
                        // this.sent = '(Fake! Dit zou je zien als het echt goed was vertsuurd, eigenlijk was er een error)'
                        // this.clearForm();
                        // this.$emit('addnotification', data)
                    })
                return false
            },
            clearForm() {
                this.articleUrl = ''
                this.image = defaultImage;
                this.title = ''
                this.channel = 'all'
                this.previousUrl = this.articleUrl
                this.scheduledTime = null
            }
        },
        watch: {
            articleId () {
                this.sent = false
                this.alreadySent = false
                this.warnNoItemFound = false
                if (this.articleId === 0 || this.articleUrl.trim() === this.previousUrl.trim()) {
                    return false
                }
                this.sendError = false
                this.previousUrl = this.articleUrl
                this.$api.getItem(this.articleId)
                    .then(item => {
                        if (item === null) {
                            this.warnNoItemFound = true
                        } else {
                            this.image = item.image
                            if (!this.title) {
                                this.title = item.title
                            }
                        }
                    })
                    .catch(error => {
                        this.sendError = 'Item ophalen voor artikel is mislukt. ' + error
                    })
                return false
            },
        }
    };
</script>

<style>
    .header {
        font-size: 24px;
        border-bottom: 1px solid silver;
        margin-bottom: 20px;
        margin-top: 20px;
        padding-bottom:8px;
    }
    .item-wrapper input,
    .item-wrapper textarea {
        margin-top: 12px;
        margin-bottom: 4px;
        width: 100%;
        box-sizing: border-box;
        padding: 8px;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        font-size: 16px;
        border: 0px solid silver;
        border-bottom: 1px solid #e0e0e0;
    }
    #title {
        font-weight: bold;
    }
    .item-wrapper input:focus,
    .item-wrapper textarea:focus {
        border-bottom: 1px solid #007bff;
    }
    .item-wrapper {
        display: flex;
    }
    .item-image {
        margin-top: 12px;
        margin-right: 16px;
        background-color: silver;
        width: 192px;
        height: 115px;
    }
    .item-details {
        flex-grow: 1;
    }
    .item-image img {
        width: 192px;
    }
    .controls {
        margin-top: 16px;
        padding-top:8px;
        display: flex;
    }
    .controls input[type="radio"] {
        opacity: 0;
        position: fixed;
        width: 0;
    }
    .controls label {
        display: inline-block;
        color: gray;
        padding: 8px 16px;
        font-size: 14px;
        border: 1px solid silver;
        border-radius: 4px;
        cursor: pointer;
        margin-right: 24px;
    }
    .controls input[type="radio"]:checked + label {
        color: green;
        border: 2px solid green;
    }
    .controls label:hover {
        color: black;
        border-color: black;
    }
    .send {
        flex-grow: 1;
        align-self: end;
    }
    .send button,
    .sending button {
        float: right;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        display: inline-block;
        background-color: #007bff;
        color: white;
        padding: 9px 17px;
        font-size: 14px;
        border: 1px solid #007bff;
        border-radius: 4px;
        cursor: pointer;
    }
    .send button:disabled {
        background-color: gray;
        border-color: silver;
        color: #e0e0e0;
        cursor: not-allowed;
    }
    .feedback {
        margin-top: 20px;
    }
    .sendError {
        padding: 28px;
        color: #721c24;
        background-color: #f8d7da;
        border-left: 4px solid red;
    }
    .sending {
        padding: 20px;
        color: #721c24;
        background-color: #f8d7da;
        border-left: 4px solid red;
        display: flex;
    }
    .sending .text {
        flex-grow: 1;
        vertical-align: baseline;
        display: flex;
        align-items: center;
    }
    .sending button {
        float: none;
        background-color: #cd1719;
        border: 1px solid red;
        margin-left: 18px;
    }
    .sending button:hover {
        background-color: red;
        border: 1px solid #cd1719;
    }
    .sending button:active {
        background-color: #f7a5ac;
        font-weight: bold;
    }
    .sent {
        padding: 28px;
        color: #155724;
        background-color: #d4edda;
        border-left: 4px solid green;
    }
    .highlight {
        border-color: red !important;
        color: red !important;
    }
    .red {
        font-size: 12px;
        color:  red;
    }
    .green {
        font-size: 12px;
        color:  green;
    }
    .item-data-input {
      padding: 0 20px;
    }

    .item-data-input > input {
      max-width: 240px;
    }

    .item-data-input label, .item-data-input label:hover {
      color: gray;
      border: 0;
      padding: 0;
      cursor: default;
    }

    #filter {
        align-self: flex-end;
        margin-bottom: 4px;
    }

</style>
